import { render, staticRenderFns } from "./addclaim.vue?vue&type=template&id=59ef38ab&scoped=true&"
import script from "./addclaim.vue?vue&type=script&lang=js&"
export * from "./addclaim.vue?vue&type=script&lang=js&"
import style0 from "./addclaim.vue?vue&type=style&index=0&id=59ef38ab&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59ef38ab",
  null
  
)

export default component.exports